<template>
  <v-row>
    <v-col cols="12">
      <v-dialog v-model="isDialogOpened" persistent max-width="1000" max-height="100%">
        <v-card>
          <v-card-title :class="`${arabic ? 'arFont' : 'enFont'} font-weight-bold`" style="font-size:22px;">
            <div>{{ i18n.print_candidate }}</div>
          </v-card-title>
          <v-card-text>
            <iframe ref="iframe" width="100%" height="100%" frameborder="0"></iframe>
          </v-card-text>
          <v-card-actions>
            <v-btn color="error" @click.prevent="isDialogOpened = false" text :class="`${arabic?'arFont':'enFont'}`">{{ i18n.close }}</v-btn>
            <v-btn @click.prevent="toPDF" color="primary" text :class="`${arabic?'arFont':'enFont'}`">
              <v-icon>print</v-icon>
              <span class="ms-1">{{ i18n.print }}</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    print_dialog: {
      type: Boolean,
      default: false
    },
    printResource: null
  },
  watch: {
    async print_dialog(value) {
      if (value) {
        const response = await this.$store.dispatch('getResource', {resource: "/can/print_/candidate/" + this.printResource.id})
        var iframeDocument = this.$refs.iframe.contentDocument || this.$refs.iframe.contentWindow.document;
        
        iframeDocument.open();
        iframeDocument.write(response);
        iframeDocument.close();
      }
      else {
        var iframeDocument = this.$refs.iframe.contentDocument || this.$refs.iframe.contentWindow.document;

        iframeDocument.open();
        iframeDocument.write("");
        iframeDocument.close();
      }
    }
  },
  computed: {
    isDialogOpened: {
      get() {
        return this.print_dialog
      },
      set() {
        this.$emit('closeDialog')
      }
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
  },
  methods: {
    toPDF() {
      this.$refs.iframe.contentWindow.print();
    }
  },
}
</script>

<style scoped>
iframe {
  min-height: 500px;
  height: 100%;
}
</style>